import type { ReactNode, SVGProps } from 'react';

export interface AnimalFaceProps extends SVGProps<SVGSVGElement> {
  size?: number;
  children: ReactNode;
}

/** Square face art from v1, sized by the parent. */
export function AnimalFace({ size = 150, children, ...rest }: AnimalFaceProps) {
  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}
